import { GetResults, AllowViewResults, GetStudentFacCode, GetMedicalResults } from "./API";
import ResultItem from "./ResultRow";
import { Translate, withLocalize } from "react-localize-redux";

import React, { useState, useEffect } from "react";

const ResultsTable = props => {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [facCode, setFacCode] = useState("");

 
  useEffect(() => {
    console.log("Allow View Result",props.batchNum);

    AllowViewResults(props.batchNum).then(messageData => {
      
      setMessage(messageData);
 
        GetStudentFacCode().then(data => {

            console.log(data);
            setFacCode(data);
        });
        //if (facCode == 102) {
        if (false) {
            console.log("Get Medical Result", props.batchNum);
            GetMedicalResults(props.batchNum).then(data => {

                console.log(data);
                setData(data);
            });
        } else {
            console.log("Get Result", props.batchNum);
            GetResults(props.batchNum).then(data => {

                console.log(data);
                setData(data);
            });
        }

        
      
    });
  }, [props.batchNum]);
  return (
    <React.Fragment>
    { message.trim() != '' && <div
        class="alert alert-yellow  fade show text-center"
        dangerouslySetInnerHTML={{ __html: message }}
          />}


          {/*{message.trim() == '' && facCode == 102 &&*/}
          {/*    <div class="alert alert-primary">{facCode}</div>}*/}


          {message.trim() == '' &&
      <table class="gv gv_result">
        <tbody>
          <tr>
            <th scope="col">

              <Translate id="results.courseCode" />
            </th>
            <th scope="col">
              <Translate id="results.courseName" />
            </th>
            <th scope="col">
              <Translate id="results.attendance" />
            </th>
            <th scope="col">
              <Translate
                options={{ renderInnerHtml: true }}
                id="results.seven"
              />
            </th>
            <th scope="col">
              {" "}
              <Translate
                options={{ renderInnerHtml: true }}
                id="results.twelve"
              />
            </th>
            <th scope="col">
              {" "}
              <Translate
                options={{ renderInnerHtml: true }}
                id="results.work"
              />{" "}
            </th>
            <th scope="col">
              {" "}
              <Translate
                options={{ renderInnerHtml: true }}
                id="results.final"
              />
            </th>
          </tr>
          {data.map(
            (item, key) =>
              (item.crsNumMod === props.crsnum && (
                <ResultItem item={item} key={item.id} />
              )) ||
              (!props.crsnum && <ResultItem item={item} key={item.id} />)
          )}
        </tbody>
              </table>

               
}
    </React.Fragment>
  );
};

export default withLocalize(ResultsTable);



// WEBPACK FOOTER //
// ./src/pages/results/ResultTable.js